{"id":"Modal","prefabs":{"default":{"children":[{"component":"Modal","options":"options:*"}]}}}